export const ADMIN_BOOKINGS_PATH = "/admin-dashboard/bookings";
export const CUSTOMER_DASHBOARD_PATH = "/user-dashboard";

export function formatNotificationTime(createdAt) {
  const ts =
    typeof createdAt === "number"
      ? createdAt
      : createdAt
        ? new Date(createdAt).getTime()
        : Date.now();

  if (Number.isNaN(ts)) return "";

  const diff = Date.now() - ts;
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  try {
    return new Date(ts).toLocaleString();
  } catch {
    return "";
  }
}
